module.exports = __webpack_public_path__ + "img/equipment-bg-icon.3af08a24.png";